import { createReducer, on } from '@ngrx/store';
import * as actions from '../../actions';
import { Action } from '@app-models/action.model';

export interface TopBarState {
  actions: Action[];
  actionActive: string;
  title: string;
}

export const topbarInitialState: TopBarState = {
  actions: [],
  actionActive: '',
  title: '',
};

// tslint:disable-next-line: variable-name
const _topbarReducer = createReducer(
  topbarInitialState,

  on(actions.topbarSetState, (state, { payload }) => ({
    ...state,
    actions: [...payload],
  })),
  on(actions.topbarDeleteState, (state) => ({
    ...state,
    actions: topbarInitialState.actions,
  })),
  //  Clicked Actions
  on(actions.clickedAction, (state, { payload }) => ({
    ...state,
    actionActive: payload,
  })),
  on(actions.topbarResetClikedAction, (state) => ({
    ...state,
    actionActive: '',
  })),
  on(actions.topBarSetTitle, (state, { title }) => ({
    ...state,
    title,
  }))
);

export function topbarReducer(state, action) {
  return _topbarReducer(state, action);
}
